// @flow
import React from "react"
import type { NotificationType } from "data/notifications/types"
import IconCheck from "./IconCheck"
import IconWarn from "./IconWarn"
import IconError from "./IconError"

type Props = {|
  type: NotificationType,
|}

const Icon = ({ type }: Props) => {
  if (type === "success") return <IconCheck />
  if (type === "warning") return <IconWarn />
  if (type === "error") return <IconError />

  return null
}

export default Icon



// WEBPACK FOOTER //
// ./src/AppComponent/Content/Notifications/NotificationTile/Icon/index.js